<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">QR Configration</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">Mode : </label>
              <input
                type="text"
                [(ngModel)]="mode"
                class="form-control"
                placeholder="Mode"
              />
            </div>
            <div class="col-md-4">
              <label for="">mc: </label>
              <input
                type="text"
                [(ngModel)]="mc"
                class="form-control"
                placeholder="mc"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">qrMedium : </label>
              <input
                type="email"
                [(ngModel)]="qrMedium"
                class="form-control"
                placeholder="qrMedium"
              />
            </div>
            <div class="col-md-4">
              <label for="">tn : </label>
              <input
                type="text"
                [(ngModel)]="tn"
                class="form-control"
                placeholder="tn"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <label for="">pn : </label>
              <input
                type="text"
                [(ngModel)]="pn"
                placeholder="pn"
                class="form-control"
              />
            </div>
            <div class="col-md-4">
              <label for="">pa : </label>
              <input
                type="text"
                [(ngModel)]="pa"
                class="form-control"
                placeholder="pa"
              />
            </div>

            <div class="col-md-2"></div>
          </div>
          <div class="row mt-3 mb-3 text-center">
            <div class="col-md-12">
              <button
                [disabled]="!mode || !mc || !qrMedium || !tn || !pn || !pa"
                (click)="qrConfig()"
                class="btn btn-primary btn-lg btn-block"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
